<template>
  <div class="wrap">
    <h1 class="row">{{translate('quality-inspection')}}</h1>
    <table>
      <tr>
        <td style="width: 50%;">
          <table class="row">
            <tr>
              <td><div class="title">{{translate('part-number')}}</div></td>
              <td><div>{{qi.part.partNumber}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('part-description')}}</div></td>
              <td><div>{{qi.part.partDescription}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('part-sn')}}</div></td>
              <td><div>{{qi.partSN}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('condition')}}</div></td>
              <td><div>{{qi.condition.title}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('supplier')}}</div></td>
              <td><div>{{qi.supplierCompany.name}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('trace')}}</div></td>
              <td><div>{{qi.tracebilityCompany.name}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('tag-by')}}</div></td>
              <td><div>{{qi.tagInfoCompany.name}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('release')}}</div></td>
              <td><div>{{qi.release.title}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('airworthy')}}</div></td>
              <td><div>{{qi.awb}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('qty')}}</div></td>
              <td><div>{{qi.qty}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('tag-date')}}</div></td>
              <td><div>{{qi.tagDate | toDate}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('mfg-date')}}</div></td>
              <td><div>{{qi.mfgDate | toDate}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('weight-dimensions')}}</div></td>
              <td colspan="3"><div>{{qi.weightDimensions}}</div></td>
            </tr>
            <tr>
              <td><div class="title">{{translate('remark')}}</div></td>
              <td colspan="3"><div>{{qi.remark}}</div></td>
            </tr>
          </table>
        </td>
        <td style="width: 50%;">
          <table class="row">
            <tr>
              <td>
                <div class="box-content">
                  <table>
                    <tr>
                      <td><div class="title">{{translate('non-incident')}}</div></td>
                      <td><div class="capitalize" :class="{'qi-false': !qi.nonIncident}">{{translate(qi.nonIncident ? 'qi-true' : 'qi-false')}}</div></td>
                    </tr>
                    <tr>
                      <td><div class="title">{{translate('technical-report')}}</div></td>
                      <td><div class="capitalize" :class="{'qi-false': !qi.technicalReport}">{{translate(qi.technicalReport ? 'qi-true' : 'qi-false')}}</div></td>
                    </tr>
                    <tr>
                      <td><div class="title">{{translate('part-visual-check')}}</div></td>
                      <td><div class="capitalize" :class="{'qi-false': !qi.partVisualCheck}">{{translate(qi.partVisualCheck ? 'qi-true' : 'qi-false')}}</div></td>
                    </tr>
                    <tr>
                      <td><div class="title">{{translate('release-approved')}}</div></td>
                      <td><div class="capitalize" :class="{'qi-false': !qi.releaseApproved}">{{translate(qi.releaseApproved ? 'qi-true' : 'qi-false')}}</div></td>
                    </tr>
                    <tr>
                      <td><div class="title">{{translate('packaging-in')}}</div></td>
                      <td><div class="capitalize" :class="{'qi-false': !qi.packagingIn}">{{translate(qi.packagingIn ? 'qi-true' : 'qi-false')}}</div></td>
                    </tr>
                    <tr>
                      <td><div class="title">{{translate('packaging-out')}}</div></td>
                      <td><div class="capitalize" :class="{'qi-false': !qi.packagingOut}">{{translate(qi.packagingOut ? 'qi-true' : 'qi-false')}}</div></td>
                    </tr>
                  </table>
                </div>
                <div class="box-content" :style="{color: '#1cabea'}">
                  <table>
                    <tr>
                      <td><div class="title" >{{translate('employee')}}</div></td>
                      <td><div>{{qi.employee.name}}</div></td>
                    </tr>
                    <tr>
                      <td><div class="title">{{translate('date')}}</div></td>
                      <td><div>{{qi.entryDate | toDate}}</div></td>
                    </tr>
                    <tr>
                      <td><div class="title">{{translate('qi-id')}}</div></td>
                      <td><div>{{qi.id}}</div></td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <hr>
    <div style="width: 50%">
      <table class="row">
        <tr style="border-bottom: 2px solid rgb(188, 187, 190); color: #1cabea;">
          <th><div class="title" style=" text-align: left">{{translate('parts-out-check-list')}}</div></th>
          <th><div class="title">{{translate('yes')}}</div></th>
        </tr>
        <tr>
          <td><div class="title">{{translate('pn-and-desc-verify')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('sn-lot-batch-verified')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('easa-tcca-verified')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('condition-verified')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('qty-verified')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('trace-nis-verified')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('package-verified')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('order-shipped-instruction')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('hazardous-mat')}}</div></td>
          <td><div class="text-center">[ ]</div></td>
        </tr>
      </table>
      <hr>
      <table>
        <tr>
          <td><div class="title">{{translate('by')}}:</div></td>
          <td><div>-</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('date')}}:</div></td>
          <td><div>-</div></td>
        </tr>
        <tr>
          <td><div class="title">{{translate('remark')}}:</div></td>
          <td colspan="3"><div>-</div></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { toDate } from '@/utils/filters'

export default {
  name: 'qi',
  props: {
    translate: {
      type: Function
    },
    qi: {
      type: Object
    }
  },
  filters: {
    toDate: toDate
  }
}
</script>
